import { createAction, props } from '@ngrx/store';
import { AuthState } from './auth.state';

export const authLogin = createAction('[Auth] Login', props<{ authData: AuthState }>());
export const authRouteToLogin = createAction('[Auth] Route To Login');
export const authLogout = createAction('[Auth] Logout');
export const authUpdate = createAction('[Auth] ChangePassword');
